import styled from '@benzinga/themetron';
import Spinner from '../../ui/Spinner';

const SmallChartSpinner = styled(Spinner)`
  font-size: 12px !important;
  line-height: 12px;
  margin-left: 12px;
`;

const MainChartSpinner = styled(Spinner)`
  align-items: center;
  display: flex;
  font-size: 20px !important;
  line-height: 20px;
`;

export { MainChartSpinner, SmallChartSpinner };
